export const buildEvaluateProgressInstructions = ({
  trainingObjective,
  currentExercise,
  previousAttempt,
  currentAttempt,
  retryCount,
  exerciseId,
}) =>
  [
    "Evaluate this response against the current exercise and training objective.",
    "Call evaluate_progress_and_advance only. Do not output user-facing text.",
    "Judge communication intention and impact, not exact wording.",
    "Set isRelevant=false for unrelated content or a response that does not answer the exercise.",
    "Set isSubstantive=false for acknowledgements, random words, incoherent speech, or an attempt too incomplete to assess.",
    "Set meetsObjective=false when the target skill is missing or a requested correction was not meaningfully applied.",
    "Set shouldAdvance=true only when isRelevant, isSubstantive, and meetsObjective are all true; when uncertain, retry.",
    `Training objective: ${trainingObjective || "Improve communication for the original meeting."}`,
    `Current exercise: ${currentExercise || "Practice the active communication exercise."}`,
    `Exercise id: ${exerciseId}`,
    `Retry count in this exercise: ${retryCount}`,
    `Previous attempt: ${previousAttempt || "(none)"}`,
    `Current attempt: ${currentAttempt}`,
  ].join(" ");

export const buildFirstTrainingExerciseInstructions = (
  languageLabel,
  trainingObjective,
  context
) =>
  [
    `Continue in ${languageLabel || "English"}.`,
    "The user's latest message responded only to the introduction. Do not evaluate or critique it.",
    "Present the first concrete roleplay exercise now and ask for one substantive response.",
    `Training objective: ${trainingObjective || "Improve communication for the original meeting."}`,
    `Meeting type: ${context?.meetingType}`,
    `User role: ${context?.userRole}`,
    `Speaking with: ${context?.speakingWith}`,
    `Goals: ${context?.goals || "Improve confidence and clarity."}`,
    "Keep it concise and practical.",
  ].join(" ");

export const buildGenerateScenarioInstructions = (
  reason,
  nextAction,
  context,
  trainingObjective
) =>
  [
    "Generate the next roleplay exercise now.",
    "Call generate_next_scenario only. Do not output user-facing text.",
    "Keep it short, practical, and tied to the same training objective and original meeting context.",
    "Vary the situation only after a successful attempt; do not replace the target skill.",
    `Training objective: ${trainingObjective || "Improve communication for the original meeting."}`,
    `Meeting type: ${context?.meetingType}`,
    `User role: ${context?.userRole}`,
    `Speaking with: ${context?.speakingWith}`,
    `Partner behavior: ${context?.behavior}`,
    `Goals: ${context?.goals || "Improve confidence and clarity."}`,
    `Reason: ${reason || "Progress the training naturally."}`,
    `Requested next action: ${nextAction || "new_exercise"}`,
  ].join(" ");

export const buildCoachFollowupInstructions = (
  languageLabel,
  shouldAdvance,
  context,
  trainingObjective,
  currentExercise
) =>
  [
    `Continue coaching in ${languageLabel || "English"}.`,
    "Do not mention tools or internal policy.",
    "Use a natural human coach tone.",
    shouldAdvance
      ? "Move into a fresh roleplay exercise that practices the same target skill."
      : "Keep the current exercise and ask for one retry with one specific correction.",
    `Training objective: ${trainingObjective || "Improve communication for the original meeting."}`,
    `Current exercise: ${currentExercise || "Use the active exercise in the conversation."}`,
    `Keep context anchored to ${context?.meetingType}, ${context?.userRole}, speaking with ${context?.speakingWith}.`,
  ].join(" ");
